document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const scrollTriggerAvailable =
    typeof ScrollTriggerUtils !== "undefined" && ScrollTriggerUtils.register();
  if (!scrollTriggerAvailable) {
    return;
  }

  const brandMain = document.querySelector(".brand-main");
  const bodyIcons = brandMain
    ? brandMain.querySelectorAll(".brand-bg-icons__item")
    : [];

  if (bodyIcons.length === 0) {
    return;
  }

  bodyIcons.forEach((icon, index) => {
    const speeds = [0.25, 0.4, 0.18, 0.35, 0.28, 0.45, 0.22, 0.3];
    const speed = speeds[index % speeds.length];
    const drift = (index % 2 === 0 ? 1 : -1) * 20;

    gsap.to(icon, {
      yPercent: -40 * speed * 100,
      xPercent: drift,
      ease: "none",
      scrollTrigger: {
        trigger: brandMain,
        start: "top bottom",
        end: "bottom top",
        scrub: 1.2,
        invalidateOnRefresh: true,
      },
    });
  });

  gsap.to(bodyIcons, {
    opacity: 0.45,
    duration: 1.5,
    ease: "power2.out",
    delay: 0.3,
  });
});
